<template>
    <div class="modal fade" id="budgetDayModal" tabindex="-1" role="dialog" aria-labelledby="budgetDayModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <form class="modal-content" @submit.prevent="store">
                <div class="modal-header">
                    <h5 class="modal-title" id="budgetDayModalLabel">{{ date.date }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12 sticky-top bg-white">
                            <div class="row border-bottom py-4" v-if="info.outcome.value !== 0">
                                <div class="col-12">
                                    <div class="day-progress">
                                        <div class="progresss-message text-center">
                                            <p v-if="amountLeft != 0 && info.percent < 70 && date.is_current">Сегодня у вас осталось еще <b>{{ amountLeft | money }} <i class="fas fa-hryvnia"></i></b> которые вы можете потратить.</p>
                                            <p v-if="date.is_current && info.percent >= 70 && info.percent < 100">Ваш бюджет на сегодня почти исчерпан. На сегодня у вас осталось <b>{{ amountLeft | money }} <i class="fas fa-hryvnia"></i></b>.</p>
                                            <p v-if="info.percent == 100 && overDraft === 0">Вы исчерпали ваш бюджет, и потратили ровно нужную сумму.</p>
                                            <p v-if="info.percent === 100 && overDraft > 0">Вы превысили траты на <b>{{ overDraft | money }} <i class="fas fa-hryvnia"></i></b></p>
                                            <p v-if="info.percent < 100 && amountLeft !== 0 && info.is_past">Вы сохранили <b>{{ amountLeft | money }} <i class="fas fa-hryvnia"></i></b>, от запланированной суммы трат.</p>
                                            <div v-if="info.percent < 100 && amountLeft !== 0 && ! info.is_past && ! info.is_current">
                                                <p>На этот день у вас доступно <b>{{ amountLeft | money }} <i class="fas fa-hryvnia"></i></b>.</p>
                                            </div>
                                        </div>
                                        <div class="progress-content">
                                            <div class="progress">
                                                <div :class="{'progress-bar': true, 'bg-success': info.percnet < 50, 'bg-warning': info.percent >= 50 && info.percent < 90, 'bg-danger': info.percent >= 90}" :style="{width: `${info.percent}%`}"></div>
                                            </div>
                                            <div class="current-time-marker" :style="{width: `${getTodayPercent}%`}" v-if="date.is_current">
                                                <time v-text="currentTime"></time>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <DayWizard :date="info" v-if="info.spent.value === 0 && info.outcome.value === 0"/>
                        </div>
                        <div class="col-12 pt-3" v-if="info.percent < 100 && amountLeft !== 0 && ! info.is_past && ! info.is_current && info.outcome.categories.length !== 0">
                            <p>План по категориям:</p>
                            <ul>
                                <li v-for="(category, index) in info.outcome.categories" :key="index">{{ category.category_id }} - {{ category.value | money }}</li>
                            </ul>
                        </div>
                        <div class="col-lg-12 border-bottom mb-3" v-if="(date.is_past || date.is_current) && info.spent.value != 0">
                            <CategoriesDonutChartLoader v-if="! loaded" />
                            <CategoriesDonutChart v-else period="custom" height="300" :date-from="date.date" :date-to="date.date" />
                        </div>
                        <div class="col-lg-12" v-if="info.spent.value !== 0">
                            <h3 class="mb-0">Операции</h3>
                            <Statement :showHeader="false" 
                                class="pt-0"
                                @deleted="transactionDeleted"
                                :statement="transactions"
                                :filters="false">
                                <div class="message">
                                    {{ $t('За этот день не найдено операций') }}
                                </div>
                            </Statement>
                        </div>
                    </div>
                </div>
                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">{{ $t('Закрыть') }}</button>
                    <button type="submit" class="btn btn-success">{{ $t('Сохранить') }}</button>
                </div> -->
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import Statement from "@/components/Statement.vue";
import CategoriesDonutChart from "@/components/Reports/CategoriesDonutChart.vue";
import CategoriesDonutChartLoader from "@/components/Loaders/CategoriesDonutChartLoader.vue";
import DayWizard from "@/components/Budget/DayWizard.vue";

export default {
    props: ['date'],

	components: {
        Statement,
        CategoriesDonutChart,
        CategoriesDonutChartLoader,
        DayWizard,
    },

    data: function() {
        return {

            info: {
                percent: 0,
                spent: {
                    value: 0,
                    categories: [],
                },
                outcome: {
                    value: 0,
                    categories: [],
                },
                income: {
                    value: 0,
                    categories: [],
                }
            },

            loaded: false,

            errors: {},
        };
    },
    
    mounted() {
        this.loadCategories();
    },

    computed: {
        ...mapGetters(['categories', 'transactions']),

        currentTime() {
            const date = new Date();

            let minutes = date.getMinutes();
            let hours = date.getHours();
            
            if(minutes < 10) {
                minutes = `0${minutes}`;
            }

            if(hours < 10) {
                hours = `0${hours}`;
            }

            return `${hours}:${minutes}`;
        },

        getTodayPercent() {
            let now = new Date();
            let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            let diff = now - today;
            let seconds = Math.round(diff / 1000);

            return (seconds / 86400) * 100;
        },
        
        amountLeft() {
            return Math.abs(this.info.outcome.value - this.info.spent.value);
        },

        overDraft() {
            return Math.abs(this.amountLeft);
        },
    },

    watch: {
        date: function(newVal) {
            // this.form.outcome.value = this.date.planned / 100;

            this.info.percent = this.date.percent;

            this.loadDayInfo();
        },
    },

    methods: {
        ...mapActions(['loadTransactions', 'loadCategories']),

        loadDayInfo() {
            this.loaded = false;

            axios.get(`/budget/days/${this.date.date}`)
                .then(({data}) => {
                    this.loadTransactions({filters: {
                        page: 1,
                        per_page: 100,
                        period: 'custom',
                        date_from: this.date.date,
                        date_to: this.date.date,
                    }});

                    this.info = data.data;

                    // this.form.outcome.valiue = this.info.outcome.value;
                    // this.form.income.valiue = this.info.income.value;

                    this.loaded = true;
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        transactionDeleted() {
            //
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
}
</script>

<style lang="scss">
.btn-split {
    span {
        font-size: 12px;
    }
}

.day-progress {
    position: relative;

    .progress-message {
        p {
            margin-bottom: 10px;
        }
    }

    .progress-content {
        position: relative;

        .current-time-marker {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 50%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            border-right: 1px solid #2a3e49;

            time {
                position: absolute;
                top: -15px;
                right: -22px;
                font-size: 12px;
                background: #2a3e49;
                color: #fff;
                padding: 3px 8px;
                border-radius: 5px;
            }
        }
        
        .progress {
            height: 48px;
            position: relative;

            .progress-bar {
                //
            }
        }
    }
}

.apexcharts-legend-series {
    display: flex;
    align-items: center;
    position: relative;

    .apexcharts-legend-marker {
        position: absolute;
        left: 10px!important;
        top: 13px!important;
        z-index: 5;
    }

    .apexcharts-legend-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #212529;
        background: rgba(166, 168, 179, 0.12);
        border-radius: 5px;
        padding: 5px;
        padding-left: 22px;
        margin: 5px 0;
        margin-left: 5px;
        width: 100%;
        position: relative;

        .category-name {
            font-size: 10px;
            word-break: none;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 10px;
            position: relative;
            z-index: 10;
        }

        .amount {
            font-size: 12px;
            font-weight: 400;
        }
    }
}
</style>